import React from 'react'

function ServiceCard({Icon, heading, para}) {
    return (
        <div>

        <div className="text-white bg-[#272729a4] py-7 px-10 flex flex-col justify-center w-[70vw] sm:w-[28vw] sm:h-72 rounded-xl shadow-lg cursor-pointer transition duration-300 hover:bg-[#4545bd] group ml-4 mt-7 sm:hover:scale-105">
            <Icon className="service__cardIcon group-hover:text-white" />
            <p className="text-2xl mt-3">{heading}</p>
                <p className="sm:w-96 sm:text-xl mt-4 text-gray-400">{para}</p>
        </div>
        </div>

    )
}

export default ServiceCard
